import { render } from "./LiteralUnlimitedNaturalData.vue?vue&type=template&id=03e8d2bd"
import script from "./LiteralUnlimitedNaturalData.vue?vue&type=script&lang=js"
export * from "./LiteralUnlimitedNaturalData.vue?vue&type=script&lang=js"

import "./LiteralUnlimitedNaturalData.vue?vue&type=style&index=0&id=03e8d2bd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__